import script from "./OSSpoofingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OSSpoofingModal.vue?vue&type=script&setup=true&lang=js"

import "./OSSpoofingModal.vue?vue&type=style&index=0&id=440af1c3&scoped=true&lang=css"
import "./OSSpoofingModal.vue?vue&type=style&index=1&id=440af1c3&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440af1c3"]])

export default __exports__